export const updateTree = (tree) => ({
  type: 'UPDATE_TREE',
  tree
})

export const snapshot = () => ({
  type: 'SNAPSHOT'
})



// WEBPACK FOOTER //
// ./src/actions/tree.js